<script lang="ts">
  import { push } from "svelte-spa-router";
  import { Button } from "$ui/button";
  import PlusCircle from "$assets/icons/plus-circle.svelte";
</script>

<div class="flex-1 flex items-center justify-center mb-24">
  <div class="flex-1 flex flex-col gap-6 justify-center items-center p-8 card max-w-[720px]">
    <div class="flex flex-col gap-4 text-center justify-center items-center">
      <h1 class="text-2xl font-semibold">Page Not Found!</h1>
    </div>
  </div>
</div>
